/**
 * 核心工具函数
 */

/**
 * 判断是否为函数
 */
export function isFunction(value: unknown): value is (...args: unknown[]) => unknown {
  return typeof value === 'function'
}

/**
 * 判断是否为对象
 */
export function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/**
 * 判断是否在浏览器环境
 */
export function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}

/**
 * 生成 UUID（v4）
 */
export function generateUUID(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * 安全的 JSON 解析
 */
export function safeJSONParse<T = unknown>(str: string, defaultValue: T): T {
  try {
    return JSON.parse(str) as T
  } catch {
    return defaultValue
  }
}

/**
 * 安全的 JSON 字符串化
 */
export function safeJSONStringify(obj: unknown, defaultValue = '{}'): string {
  try {
    return JSON.stringify(obj)
  } catch {
    return defaultValue
  }
}

/**
 * 解析 URL（简化版）
 */
export function parseURL(url: string): { hostname: string; pathname: string; search: string } {
  try {
    const urlObj = new URL(url)
    return {
      hostname: urlObj.hostname,
      pathname: urlObj.pathname,
      search: urlObj.search,
    }
  } catch {
    return { hostname: '', pathname: '', search: '' }
  }
}

/**
 * 解析 URL query 参数
 */
export function parseUrlQuery(url: string): Record<string, string> {
  try {
    const urlObj = new URL(url)
    const params: Record<string, string> = {}
    urlObj.searchParams.forEach((value, key) => {
      params[key] = value
    })
    return params
  } catch {
    return {}
  }
}
/**
 * 判断是否支持 sendBeacon
 */
export function isSupportBeacon(): boolean {
  return typeof navigator !== 'undefined' && !!navigator.sendBeacon
}
